<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>{{ modoExcecao ? 'Regra de Exceção' : 'Regra Padrão' }}</span>
        <div class="section-title-actions ms-auto">
            <span class="personalizar-tooltip-wrap"
                [matTooltip]="personalizarTooltip"
                [matTooltipDisabled]="!personalizarBloqueado">
                <button mat-button type="button" class="btn-section"
                    [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0"
                    [disabled]="personalizarBloqueado"
                    (click)="onPersonalizar()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </span>
        </div>
    </div>

    <div class="row g-3">

        <!-- Usar o mesmo CST -->
        <div class="col-12">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isSincronizarCst">
                Usar o mesmo CST para PIS e COFINS
            </mat-slide-toggle>
        </div>

        <!-- Código -->
        <div class="col-12">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ modoExcecao ? 'Código da exceção' : 'Código' }}</mat-label>
                <mat-select formControlName="cstPis">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (c of codigoTributosDoTipoOperacao; track c.codigo) {
                    <mat-option [value]="c.codigo">{{ c.codigo }} – {{ c.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('cstPis')?.hasError('required') && form.get('cstPis')?.touched) {
                <mat-error>Código é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Alerta do código -->
        @if (texto) {
        <div class="col-12">
            <app-alert-card [type]="texto.alertaTipo" [title]="texto.alertaTitulo">
                {{ texto.alertaTexto }}
            </app-alert-card>
        </div>
        }

        <!-- Tributação por alíquota -->
        @if (ativo('pPIS')) {
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota PIS (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pPis">
                @if (form.get('pPis')?.hasError('required') && form.get('pPis')?.touched) {
                <mat-error>Alíquota do PIS é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- Tributação por unidade de medida (ad rem) -->
        @if (ativo('vAliqProd')) {
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota por unidade (R$)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="vAliqProd">
                @if (form.get('vAliqProd')?.hasError('required') && form.get('vAliqProd')?.touched) {
                <mat-error>Alíquota por unidade é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- Substituição Tributária (PIS-ST) — CST 05 -->
        @if (algumAtivo(['pPISST', 'vAliqProdST'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Substituição Tributária (PIS-ST)</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pPISST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota PIS-ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pPisSt">
                            @if (form.get('pPisSt')?.hasError('required') && form.get('pPisSt')?.touched) {
                            <mat-error>Informe a alíquota ou o valor por unidade.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('vAliqProdST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota PIS-ST por unidade (R$)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="vAliqProdSt">
                            @if (form.get('vAliqProdSt')?.hasError('required') && form.get('vAliqProdSt')?.touched) {
                            <mat-error>Informe a alíquota ou o valor por unidade.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- Gera crédito (apenas na regra principal) -->
        @if (!modoExcecao) {
        <div class="col-12 col-md-4 d-flex align-items-center">
            <mat-slide-toggle class="app-toggle-compact" formControlName="geraCredito">
                Gera crédito de PIS
            </mat-slide-toggle>
        </div>
        }

    </div>
</div>
</div>
